export { Details } from './Details'
export { History } from './History'
export { Footer } from './Footer'
